"use strict";

$(document).ready(function () {
  var page;
  var templateId = $('body').data('template');

  /*
   * Init Nette JS
   */
  $.nette.init();
  //$.nette.ext('redirect');

  /*
   * Init page controller by template
   */

  switch (templateId) {
    case "users":
      page = new UsersController();
      break;
    case "records-offers":
      page = new RecordsController();
      break;
    case "records-orders":
      page = new RecordsController();
      break;
    case "records-add":
      page = new RecordsAddEditController();
      break;
    case "records-edit":
      page = new RecordsAddEditController();
      break;
    case "configuration-list":
      page = new ConfigurationController();
      break;
    case "records-ordersupplier":
      page = new OrderSupplierController();
      break;
    default:
      // init generic page controller for other templates
      page = new PageController();
      break;
  }

  /*
  * Init share links
  */
  SharingUtils.initShareLinks();
  var form = new FormComponent();
  var mobileMenu = new MobileMenu();
});